import { render, staticRenderFns } from "./company_admin_table1.vue?vue&type=template&id=0fb973a8&scoped=true&"
import script from "./company_admin_table1.vue?vue&type=script&lang=js&"
export * from "./company_admin_table1.vue?vue&type=script&lang=js&"
import style0 from "./company_admin_table1.vue?vue&type=style&index=0&id=0fb973a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb973a8",
  null
  
)

export default component.exports